export default __webpack_public_path__ + "static/media/hazard-sign.aa81f813.png";